import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import IdentityCompletionFlow from "@/customComponents/uiComponents/global/IdentityCompletionFlow.jsx";
import {queryClient} from "@/lib/queryClient";
import {storage, STORAGE_KEYS} from "@/utils/storage";

/**
 * "Your profile is incomplete" — collects whatever the booking gate still wants.
 *
 * The backend refuses POST /trips with `422 identity_incomplete` until the account has a
 * real name, email AND phone. Reached from orderDetails / mainPolicies Continue, BEFORE
 * payment (see utils/identityGate `bookingIdentityStep`). The missing list and onward step
 * come through storage — steps share one fixed prop shape.
 *
 * The steps themselves live in IdentityCompletionFlow: name through the account update, and
 * a VERIFIED email / phone (add → code → verify → set default). `/complete-identity` is no
 * longer called — it stored contacts unverified.
 */
export function CompleteProfile({setStep, closeModal}) {
    const missing = (() => {
        const stored = storage.get(STORAGE_KEYS.IDENTITY_MISSING);
        return Array.isArray(stored) && stored.length ? stored : ["phone"];
    })();
    const nextStep = storage.get(STORAGE_KEYS.IDENTITY_NEXT_STEP) || "paymentCards";

    const done = () => {
        storage.remove(STORAGE_KEYS.IDENTITY_MISSING);
        storage.remove(STORAGE_KEYS.IDENTITY_NEXT_STEP);
        queryClient.invalidateQueries({queryKey: ['user', 'account']});
        setStep(nextStep);
    };

    return (
        <>
            <ModalHeader
                title=""
                extraClasses=""
                totalSteps={0}
                cancelButton={false}
                backStep="orderDetails"
                showBackButton={true}
                setStep={setStep}
                closeModal={closeModal}
            />

            <div className="modalPages-spacing complete-profile">
                <h4>Your profile is incomplete</h4>
                <IdentityCompletionFlow missing={missing} onCompleted={done}/>
            </div>
        </>
    );
}

export default CompleteProfile;
